import BaseApiAction from "@Actions/base-api-action";

export default class CreateCustomer extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: "stripe-temp-createCustomer",
      payload: {
        first: this._payload.first,
        last: this._payload.last,
        email: this._payload.email,
        ...this.addFieldIfExists("pass", this._payload.pass),
        ...this.addFieldIfExists("uid", this._payload.uid),
        ...this.addFieldIfExists("referral", this._payload.referral),
        ...this.addFieldIfExists("return_url", this._payload.return_url),
      },
    });
  }

  onSuccess(data: any) {
    this._state.admin.users.events.userCreated.emit();
    super.onSuccess(data);
  }
}
